export default __webpack_public_path__ + "static/media/logo_icon.838689c4.png";